import React, { useEffect } from 'react';

export default function ModalMultiEmpresa({
  isOpen,
  onClose,
  empresas = [],
  onSelectEmpresa,
  empresaAtivaId,
}) {
  useEffect(() => {
    function handleEsc(e) {
      if (e.key === 'Escape') onClose();
    }
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      return () => document.removeEventListener('keydown', handleEsc);
    }
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) {
      console.log('🟢 [Modal] ABERTO');
      console.log('📦 [Modal] empresas recebidas:', empresas);
      console.log('🏢 [Modal] empresaAtivaId:', empresaAtivaId);
    }
  }, [isOpen, empresas, empresaAtivaId]);

  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm transition-all duration-300"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl shadow-2xl p-8 max-w-lg w-full relative animate-fade-in-up"
        style={{ animation: 'fade-in-up 0.5s cubic-bezier(.68,-0.55,.27,1.55)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-blue-700 p-2 transition-all rounded-full"
          onClick={onClose}
          aria-label="Fechar"
        >
          <svg width="24" height="24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <div className="flex items-center gap-2 mb-6">
          <svg className="w-8 h-8 text-blue-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M3 21V7a2 2 0 012-2h3a2 2 0 012 2v14M9 21V7M15 21V3a2 2 0 012-2h3a2 2 0 012 2v18" />
          </svg>
          <h2 className="text-2xl font-bold text-blue-900 tracking-tight">Escolha sua empresa</h2>
        </div>

        <div className="space-y-4">
          {!empresas || empresas.length === 0 ? (

            <div className="text-gray-500 text-center py-6">
              ⏳ Carregando ou nenhuma empresa disponível.
            </div>
          ) : (
            empresas.map((empresa) => {
              const nomeExibido = empresa.nome_fantasia || empresa.nome || 'Empresa';
              const logoUrl =
                empresa.logo_url ||
                `https://api.dicebear.com/7.x/identicon/svg?seed=${encodeURIComponent(nomeExibido)}`;

              return (
                <button
                  key={empresa.id}
                  className={`w-full flex items-center gap-4 px-5 py-4 rounded-2xl shadow-md transition transform hover:scale-105 hover:bg-blue-50
                    ${empresaAtivaId === empresa.id ? 'border-2 border-blue-700 bg-blue-100' : 'border border-gray-200 bg-white'}`}
                  onClick={() => {
                    console.log('✅ [Modal] Empresa selecionada:', empresa);
                    onSelectEmpresa(empresa);
                    onClose();
                  }}
                >
                  <img
                    src={logoUrl}
                    alt={nomeExibido}
                    className="w-12 h-12 rounded-full border-2 border-blue-300 object-cover bg-gray-100"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = '/default-user.png';
                      console.warn('⚠️ Erro ao carregar logo da empresa:', nomeExibido);
                    }}
                  />
                  <span className="flex-1 text-lg font-semibold text-blue-800">{nomeExibido}</span>

                  {empresaAtivaId === empresa.id && (
                    <span className="ml-auto text-green-500 font-bold flex items-center gap-1">
                      <svg width="22" height="22" fill="none">
                        <circle cx="11" cy="11" r="10" fill="#22c55e" />
                        <path d="M7 12l2.5 2.5L15 9" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                      </svg>
                      Ativa
                    </span>
                  )}
                </button>
              );
            })
          )}
        </div>

        <style>{`
          @keyframes fade-in-up {
            0% { opacity: 0; transform: translateY(40px) scale(0.98); }
            100% { opacity: 1; transform: translateY(0) scale(1); }
          }
        `}</style>
      </div>
    </div>
  );
}
